import { AppConstant } from "../constants/app.constant";
import UtilService from "./util.service";

export const NativeBridge = {

    getHeaders: function(method, url, params) {
        if (UtilService.isIOSWebview() && window.webkit) {
            // If WKWebView available, then trigger app event
            return getHeadersWebkit(method, url, params);
        }
        else {
            // Call UIWebView method
            return getHeadersMyAirtelAppReact(method, url, params)
        }
    },

    onGetHeaderSuccess: function (jsonString) {
        const appHeaders = String(jsonString).replace(/\n/g, '')
        window.headersFromWebkit = JSON.parse(appHeaders);
    },


    generatePayload: function(eventName, inputParams, callback) {
        const payload = {}
        payload[AppConstant.EVENT_NAME] = eventName
        if (inputParams && Object.keys(inputParams).length > 0) {
            payload[AppConstant.INPUT_PARAMS] = inputParams
        }
        if (callback) {
            payload[AppConstant.CALLBACK] = callback
        }
        return payload
    }
}

const getHeadersWebkit = (method, url, params) => {
    const payload = NativeBridge.generatePayload(AppConstant.GET_HEADERS_EVENT, {
        [AppConstant.GET_HEADERS_METHOD]: method,
        [AppConstant.GET_HEADERS_URL]: url,
        [AppConstant.GET_HEADERS_PARAMS]: params
    }, AppConstant.GET_HEADERS_CALLBACK)
    
    window.webkit.messageHandlers.triggerAppEvent.postMessage(payload);
    const promise = new Promise(resolve => {
        let retry = 0
        const clearIntervalVal = setInterval(() => {
            retry += 1
            if ((window.headersFromWebkit && window.headersFromWebkit[url]) || retry > 5) {
                clearInterval(clearIntervalVal)
                const headers = window.headersFromWebkit || {}
                resolve(headers[url])
            }
        }, 100)
    })
    return promise
} 

const getHeadersMyAirtelAppReact = (method, url, params) => {
    const promise = new Promise(resolve => {
        const appHeadersObj = window.MyAirtelAppReact.getHeaders(method, url, params);
        let appHeaders = String(appHeadersObj).replace(/\n/g, '')
        appHeaders = JSON.parse(appHeaders);
        resolve(appHeaders)
    })
    return promise
} 

export const initiateNativeBridge = () => {
    //Exposing native bridge methods on window.app object
    window.app = NativeBridge;
}